<div *ngIf="streamCorrect">
  <div style="background-color: #202020; " *ngIf="!showLoading">
    
  <div style="width: 100%;" >

    
    <!-- Start Main Content -->
    <div class="main-content" style=" background-image: url({{appBundlesHP.bundle_background_img}}); background-repeat: no-repeat; background-color: #202020;
    background-size: 100% 100%; padding: 0px; ">
    <div>
        <!-- Start Play Details Section -->
        <section class="play-details">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row">
                            <div class="col-md-12"  style="padding-left: 0px !important; padding-right: 0px !important;">
                                <div class="play-thumb mb-4">
                                    <img class="img-fluid" src="{{appBundlesHP.bundle_poster}}" alt="">
                                    <!--div *ngFor="let image of _albums; let i=index">
                                      <img class="img-fluid" [src]="image.src" (click)="open(i)" />
                                    </div-->
                                </div>
                               
                            </div>
                           
                            <!-- Col End -->
                        </div>
                        <div class="row">
                          <div class="col-md-12"  style=" padding-left: 0px !important; padding-top: 20px; padding-right: 0px !important;">
                            <a  (click)="onHowtowatchonTVClick()" 
                              style="border: 2px solid black;"  class="btn d-block hvr-sweep-to-right" tabindex="0">
                              <b>How to watch it on TV</b></a>

                            
                          </div>
                         
                          <!-- Col End -->
                        </div>
                        <div class="row">
                          <div class="col-md-12"  style=" padding-left: 0px !important; padding-top: 20px; padding-right: 0px !important;">
                            <a  (click)="onDealsClick()" 
                              style="border: 2px solid black;"  class="btn d-block hvr-sweep-to-right" tabindex="0">
                              <b>DEALS EVERYWHERE</b></a>

                            
                          </div>
                         
                          <!-- Col End -->
                        </div>
                        <!-- Row End -->
                    </div>
                    <!-- Col End -->
                    <div class="col-md-8">
                        <div class="play-details-content">
                         
                            <div class="title-block d-flex align-items-center justify-content-between">
                                <h2 class="play-title">{{appBundlesHP.bundle_name}}</h2>
                            </div>
                            <!-- Title Block -->
                            
                            <!-- Details Info -->
                            <!--div class="details-desc">
                                <p [innerHTML]="appBundlesHP.bundle_description"  style="margin-bottom: 35px !important;"></p>
                            </div-->
                            <div class="details-desc">
                              
                                <div class="row" style="margin-bottom: 35px !important;">
                                  <div class="col-md-9 col-sm-12 details-desc1"  style="padding-top: 30px;">
                                      
                                    <b>THEATER - 1</b><BR>
                                  </div>
                                  <div class="col-md-3  col-sm-12  details-desc2"  style="padding-top: 30px;">
                                    
                                    <a  class="btn d-block hvr-sweep-to-right" (click)="watchPromo('1')" tabindex="0" style="border: 2px solid black;" >
                                      <i class="icofont-ui-play mr-2" aria-hidden="true"></i>Promo</a>

                                  </div>
                                  <div class="col-md-12  col-sm-12  details-desc2"  style="">
                                  <b>LAST THUG STANDING.</b> After legendary rapper Big Syke is released from prison,
                                    he prepares to get his life back on track. Big Syke finds himself on a 
                                    personal journey that will lead him to the "Last Thug Standing"   
                                  </div>

                                  <div class="col-md-9 col-sm-12 details-desc1"  style="padding-top: 30px;">
                                      
                                    <b>THEATER - 2</b><BR>
                                  </div>
                                  <div class="col-md-3  col-sm-12  details-desc2"  style="padding-top: 30px;">
                                    
                                    <a  class="btn d-block hvr-sweep-to-right" (click)="watchPromo('2')" tabindex="0" style="border: 2px solid black;" >
                                      <i class="icofont-ui-play mr-2" aria-hidden="true"></i>Promo</a>

                                  </div>
                                  <div class="col-md-12  col-sm-12  details-desc2"  style="">
                                  <b>WATTS CITY SCHEMERS.</b> Sonny is a hitman at the top of his game who is hired
                                  to target all the gangsters  in Watts City, whom are all conspired 
                                  for a massive financial theft. While on his top-secret hunt, Sonny 
                                  comes face to face with his own demons.
                                  </div>

                                  <div class="col-md-9 col-sm-12 details-desc1"  style="padding-top: 30px;">
                                      
                                    <b>THEATER - 3</b><BR>
                                  </div>
                                  <div class="col-md-3  col-sm-12  details-desc2"  style="padding-top: 30px;">
                                    
                                    <a  class="btn d-block hvr-sweep-to-right" (click)="watchPromo('3')" tabindex="0" style="border: 2px solid black;" >
                                      <i class="icofont-ui-play mr-2" aria-hidden="true"></i>Promo</a>

                                  </div>
                                  <div class="col-md-12  col-sm-12  details-desc2"  style="">
                                  <b>LONG BEACH MEDALLION.</b> After a medallion is passed on to Baby G for
                                   collateral, the city of Long Beach finds itself in the middle of an 
                                   unusual curse. But when a group of gangsters come looking for their stolen 
                                   chain, all bets are off.   
                                  </div>

                                  <div class="col-md-9 col-sm-12 details-desc1"  style="padding-top: 30px;">
                                      
                                    <b>THEATER - 4</b><BR>
                                  </div>
                                  <div class="col-md-3  col-sm-12  details-desc2"  style="padding-top: 30px;">
                                    
                                    <a  class="btn d-block hvr-sweep-to-right" (click)="watchPromo('4')" tabindex="0" style="border: 2px solid black;" >
                                      <i class="icofont-ui-play mr-2" aria-hidden="true"></i>Promo</a>

                                  </div>
                                  <div class="col-md-12  col-sm-12  details-desc2"  style="">
                                  <b>GETWAY ROBBER.</b> Hit-man turned bank robber Greg Dean becomes 
                                  covert as he protects himself and his prized payload from law enforcement in 
                                  a high stakes chase through Los Angeles.   
                                  </div>

                                  <div class="col-md-9 col-sm-12 details-desc1"  style="padding-top: 30px;">
                                      
                                    <b>THEATER - 5</b><BR>
                                  </div>
                                  <div class="col-md-3  col-sm-12  details-desc2"  style="padding-top: 30px;">
                                    
                                    <a  class="btn d-block hvr-sweep-to-right" (click)="watchPromo('5')" tabindex="0" style="border: 2px solid black;" >
                                      <i class="icofont-ui-play mr-2" aria-hidden="true"></i>Promo</a>

                                  </div>
                                  <div class="col-md-12  col-sm-12  details-desc2"  style="">
                                  <b>ROCK, PAPER, SCISSORS.</b> Joseph, a U.S. Marine, becomes torn 
                                  between the duty to his country and the loyalty to his family. He 
                                  embarks on a deadly quest testing the duality of his devotion.  
                                  </div>

                                </div>
                              
                            </div>
                            
                            
                            <!-- Movie Persons -->
                            <div class="details-buttons">
                                <div class="row d-flex align-items-center">
                                   
                                    <!-- Col End -->
                                   
                                    <!-- Col End -->
                                    <div class="col-md-3 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;"></div>
                                    <div class="col-md-6 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;">
                                     
                                      <a class="btn d-block hvr-sweep-to-right" tabindex="0" (click)="finalpay(1)" *ngIf="!bundPurchased"
                                        style="border: 2px solid black;  font-weight: bold;" >
                                        Bundle Bargain Rental  <br>All 5 films for 20 days for $4.99</a>

                                       <a class="btn d-block hvr-sweep-to-right" tabindex="0"  *ngIf="bundPurchased"
                                        style="border: 2px solid black;  font-weight: bold;" >Purchased on {{bundPurchasedOn}}</a>

                                    </div>
                                    <div class="col-md-3 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;"></div>
                                    
                                   
                                </div>
                                <div class="row d-flex align-items-center" style="padding-top: 10px;">
                                   
                                  <!-- Col End -->
                                  <div class="col-md-3 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;"></div>
                                  <!-- Col End -->
                                  <div class="col-md-6 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;">
                                    <a  class="btn d-block hvr-sweep-to-right" tabindex="0" (click)="openLinkAll('https://everywheretheater.com/')"
                                      style="border: black 2px solid; font-weight: bold;" >
                                      <i class="icofont-bill mr-2" aria-hidden="true"></i>Cash App and Gift Ticket Purchase</a>
                                  </div>
                                  <div class="col-md-3 col-xl mb-xl-0 mb-3 col-sm-12" style="text-align: center;"></div>
                                  
                                  
                                 
                              </div>

                                
                                <!-- Row End -->
                            </div>
                            <div class="details-desc">
                              
                              <div class="row" style="margin-bottom: 35px !important;">
                                <div class="col-md-12 col-sm-12 details-desc3"  style="text-align:center; padding-top: 30px;">
                               <b> For more detailed information about each of the films and/or for 
                                individual film rentals, please click on the titles below.</b>
                                </div>
                              </div>
                            </div>
                            <!-- Details Buttons End -->
                            <div class="details-desc" style="text-align: center;">
                              
                              <h2 style="padding-top: 20px; font-family: 'Roboto', sans-serif !important; color: white !important; font-weight: bold;" class="h2_class" >Share on social networks</h2>
                              <!--social icons-->
                              <div class="content_position" style="text-align:center;">
                                <iframe src="https://swee.swigit.com/sweebundle.html"
                                  style="border: none; overflow: hidden; text-align: center;" width="85%" height="90px"></iframe>
                              </div>
                            </div>
                           

                        </div>
                        <!-- Details Content End -->
                    </div>
                    <!-- Col End -->
                </div>
                <!-- row End -->
            </div>
            <!-- Container End -->
        </section>
       
        <!-- Play Details Section End -->
        <!-- Start Related Movies Section -->
       
        <!-- Related Movies Section End -->
    </div>
  </div>
    <!-- Main Content End -->
    <!-- Start Footer Section -->
    
    <!-- Footer Section End -->
    <!-- Start Copyrights Section -->
    
    <!-- Copyrights Section End -->
    <!-- To Top Button Start-->
    <!--div class="back-to-top-btn">
        <div class="back-to-top" style="display: block;">
            <a aria-hidden="true" class="fas fa-angle-up" href="#"></a>
        </div>
    </div-->
    <!-- To Top Button End -->

<!-- Main Class End -->

<!-- Start Filter Sidebar -->

<!-- Filter Sidebar End -->
  
</div>
  </div>
  
  <section class="pupular"  >
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                
                <h2 class="block-title" >Film Selections</h2>
                <div class="owl-carousel owl-theme" id="pupular-slider"> 
                  <div class="item"  *ngFor="let swigitStreamArr of this.swigitsHP.streams;">
                      <div class="video-block"    >
                          <div  class="video-thumb position-relative thumb-overlay">
                              <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}" target="_blank">
                                <img alt=""   class="" src="{{swigitStreamArr.stream_small_thumb_image}}"></a>
                              <div class="box-content" >
                                <ul class="icon">
                                    <li>
                                      <!--a href="http://localhost:4200/app?title=gatewayrobber&domain=swee" target="_blank"><i class="fas fa-info"></i></a-->
                                      <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}" target="_blank"><i class="fas fa-info"></i></a>
                                    </li>
                                </ul>
                            </div>
                          </div>
                      </div>
                      
                  </div>
              </div>
            </div>
        </div>
    </div>
</section>










                
  <app-spinner *ngIf="showLoading">
  </app-spinner>
</div>
<div *ngIf="!streamCorrect" style="background-color: black;"><img src="{{contentBackgroundStyle}}" width="90%">
</div>
